import { Badge } from "@/components/ds/Badge/Badge";
import { MapPinIcon } from "@/icons/MapPinIcon";
import styles from "./MockDashboard.module.css";

const SITES = [
  { name: "Canary Wharf Tower", cleaner: "Sarah M.", status: "on-site" as const, progress: 65 },
  { name: "MediaCityUK", cleaner: "James K.", status: "on-site" as const, progress: 30 },
  { name: "Brindleyplace", cleaner: "Priya S.", status: "late" as const, progress: 0 },
  { name: "Wellington Place", cleaner: "David O.", status: "complete" as const, progress: 100 },
] as const;

type Status = typeof SITES[number]["status"];

const STATUS_BADGE: Record<Status, { variant: "success" | "warning" | "danger"; label: string }> = {
  "on-site": { variant: "success", label: "On Site" },
  "late": { variant: "danger", label: "Late" },
  "complete": { variant: "success", label: "Complete" },
};

export function MockDashboard() {
  return (
    <div className={styles.dashboard} aria-hidden="true">
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <span className={styles.pulse} />
          <MapPinIcon width={14} height={14} />
          <span className={styles.headerTitle}>Live GPS Attendance</span>
        </div>
        <div className={styles.headerRight}>
          <Badge variant="success">3/4 on site</Badge>
          <span className={styles.time}>09:42 AM</span>
        </div>
      </div>

      <div className={styles.body}>
        {SITES.map((site) => {
          const badge = STATUS_BADGE[site.status];
          return (
            <div key={site.name} className={styles.row}>
              <div className={styles.siteInfo}>
                <span className={styles.siteName}>{site.name}</span>
                <span className={styles.cleanerName}>{site.cleaner}</span>
              </div>
              <div className={styles.siteStatus}>
                {site.status === "on-site" && (
                  <div className={styles.progressBar}>
                    <div
                      className={styles.progressFill}
                      style={{ width: `${site.progress}%` }}
                    />
                  </div>
                )}
                <Badge variant={badge.variant}>{badge.label}</Badge>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
